























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  components: {},
  computed: {},
})
export default class TrialCancellationActionsUi extends Vue {
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: false }) continueDisabled!: boolean;
  @Prop({ default: false }) hideAbortBtn!: boolean;
  @Prop({ default: 'Keep my free trial' }) abortBtnText!: string;
  @Prop({ default: 'Continue cancellation' }) continueBtnText!: string;

  private async handleAbort() {
    this.$emit('abort');
  }

  private async handleContinue() {
    this.$emit('continue');
  }
}
